import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import Select from "react-select";
import DisplayFields from "./displayFields";
import DynamicForm from "./dynamicForm";
import TableComponent from "../../GeneralComponents/SearchTable/tableComponent";
import PasswordModal from "./passwordModal/passwordModal";
import QRModalWindow from "../commonComponents/QRModalWindow/QRModalWindow";
import EngineModal from "./engineModal/engineModal";
import EngineStaticModal from "./engineModal/engineStaticModal";
import OtherInformationRHF from "../commonComponents/otherInformationRHF/OtherInformationRHF";
import ResultModalText from "./resultModalText/resultModalText";

import {
  sendPersonalNum,
  interestedUserData,
  createBill,
  saveApplicationData,
  downloadReportBoatCardModif,
  deregisterEngine,
  sendUnp,
  DEREGISTER_RESET_STATUS_ERROR,
  GET_DATA_BU_UNP_REQUEST,
  CREATE_BILL_SUCCESS,
} from "../../../redux/RegistrationChangesInformationRHFReducer/actionsRegistrationChangesInformationRHF";
import {
  getGorodByObl,
  getGorodIdByRayons,
  getRayonByOblast,
  getRayonsByGorodId,
} from "../../../redux/rayonAndRegionReducer/actionRayonAndRegion";

import {
  ARRESTS_IMPOSED,
  entityInformationAboutInterestedPartyText,
  getEntityInformationAboutInterestedPartyInput,
  getInformationAboutAgentInterestedPartyInput,
  getInformationAboutInterestedPartyInput,
  informationAboutInterestedPartyText,
  informationAboutSmallVesselText,
  registrationChangeType,
  registrationFieldsHeader,
  setDisabledForFields,
  setSelectOptionsForFields,
  setRequirementForFields,
  SMALL_BOAT_OUTBOARD_ENGINES,
  SPECIAL_NOTES,
  STATIONARY_ENGINES_SMALL_VESSELS,
  getInformationAboutSmallVessel,
} from "./registrationChangesInformationRHFNewData";

import { SET_INTERESTED_USER_DATA } from "../../../redux/types";

import { registrationStyles } from "./registrationChangesInformationRHFNewStyles";
import styles from "./registrationChangesInformationRHFNew.module.css";
import stylesFirsForm from "./styles/stylesFirsForm.module.css";
import stylesSecondForm from "./styles/stylesSecondForm.module.css";
import stylesThirdForm from "./styles/stylesThirdForm.module.css";
import stylesEntityForm from "./styles/stylesEntityForm.module.css";

const RegistrationChangesInformationRHFNew = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
    setError,
    clearErrors,
    trigger,
    reset,
    formState: { errors, dirtyFields },
  } = useForm({
    defaultValues: {
      mode: "onChange",
      selectedPay: { value: false, label: "Нет" },
      appDate: getCurrentDateFormatted(),
    },
  });

  const { idBoadCard, modeView, idTypeStatement } = location.state || {};

  const [isCreateEnginData, setIsCreateEnginData] = useState(false);
  const [passwordModalShow, setPasswordModalShow] = useState(false);
  const [agenNumber, setAgenNumber] = useState(null);
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [enginModalOpen, setEnginModalOpen] = useState(false);
  const [enginModalData, setEnginModalData] = useState({});
  const [enginStaticModalData, setEnginStaticModalData] = useState(false);
  const [enginStaticModalOpen, setEnginStaticModalOpen] = useState(false);
  const [remainingPower, setRemainingPower] = useState(0);
  const [enginData, setEnginData] = useState([]);
  const [enginStaticData, setEnginStaticData] = useState([]);
  const [nextId, setNextId] = useState(1);
  const [showTakeOffModal, setShowTakeOffModal] = useState(false);
  const [takeOffTextModal, setTakeOffTextModal] = useState("");
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultTextModal, setResultTextModal] = useState("");
  const [resultTextHeaderModal, setResultTextHeaderModal] = useState("");
  const [saveSubmitData, setSaveSubmitData] = useState(null);
  const [isPrinted, setIsPrinted] = useState(false);
  const [interestedPartyFields, setInterestedPartyFields] = useState(
    getInformationAboutInterestedPartyInput(),
  );
  const [entityFields, setEntityFields] = useState(
    getEntityInformationAboutInterestedPartyInput(),
  );
  const [agentFields, setAgentFields] = useState(
    getInformationAboutAgentInterestedPartyInput(),
  );
  const [smallVesselFields, setSmallVesselFields] = useState(
    getInformationAboutSmallVessel(),
  );

  const firstRender = useRef(true);

  const changeTypeWatch = watch("changeTypeId");
  const gorodIdWatch = watch("gorodId");
  const agentGorodIdWatch = watch("agentGorodId");
  const oblIdWatch = watch("oblId");
  const rayonIdWatch = watch("rayonId");
  const agentRayonIdWatch = watch("agentRayonId");
  const agentOblIdWatch = watch("agentOblId");
  const boatTypeWatch = watch("boatType");
  const persNumWatch = watch("persNum");
  const agentPersNumWatch = watch("agentPersNum");
  const selectedPayWatch = watch("selectedPay");
  const engineNumWatch = watch("engineNum");
  const engpwrmaxWatch = watch("engpwrmax");

  const userData = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.interestedUser,
  );
  const userDataByNumber = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.userByPersonalNum,
  );
  const agentDataByNumber = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.agentByPersonalNum,
  );
  const dictionaryReducer = useSelector((state) => state.dictionaryReducer);
  const rayonAndRegionReducer = useSelector(
    (state) => state.rayonAndRegionReducer,
  );
  const serviceBill = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.serviceBill,
  );
  const deregisterEngineLoading = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.deregisterEngineLoading,
  );
  const deregisterEngineError = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.deregisterEngineError,
  );
  const registrationResult = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.registrationResult,
  );
  const registrationIsLoading = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.registrationIsLoading,
  );
  const appName = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.appName,
  );
  const dataByUnp = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.dataByUnp,
  );
  const dataByUnpError = useSelector(
    (state) => state.registrationChangesInformationRHFReducer.dataByUnpError,
  );
  const userByPersonalNumStatus = useSelector(
    (state) =>
      state.registrationChangesInformationRHFReducer.userByPersonalNumStatus,
  );

  const handleShowTakeOffModal = () => setShowTakeOffModal(true);
  const handleCloseTakeOffModal = () => setShowTakeOffModal(false);

  const handleShowResultModal = () => setShowResultModal(true);
  const handleCloseResultModal = () => {
    setShowResultModal(false);
    dispatch({ type: DEREGISTER_RESET_STATUS_ERROR });

    if (registrationResult === "success") {
      navigate("/reginformationchanges");
    }
  };

  const QRModalWindowCloseModal = () => {
    setShowBillContractModal(false);
    dispatch({ type: CREATE_BILL_SUCCESS, payload: null });
    dispatch(saveApplicationData(idBoadCard, saveSubmitData, undefined));
  };

  const handlePasswordModalClose = () => setPasswordModalShow(false);
  const handlePasswordModalShow = () => setPasswordModalShow(true);

  const openEngineModal = () => {
    setEnginModalData({});
    setEnginModalOpen(true);
  };

  const closeEngineModal = () => {
    setEnginModalOpen(false);
    setEnginStaticModalOpen(false);
  };

  const handleSavePassword = (newPassword) => {
    dispatch(
      sendPersonalNum(
        agenNumber === 1 ? persNumWatch : agentPersNumWatch,
        newPassword,
        agenNumber,
        dictionaryReducer?.userInfo?.userid,
      ),
    );
  };

  function getCurrentDateFormatted() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const setEngines = () => {
    if (changeTypeWatch?.value === 3) {
      if (boatTypeWatch?.value === 6 || boatTypeWatch?.value === 2) {
        return enginData;
      }
    } else {
      if (userData?.boatType?.value === 6 || userData?.boatType?.value === 2) {
        return enginData;
      }
    }
    return [];
  };

  const setStaticEngines = () => {
    if (changeTypeWatch?.value === 3) {
      if (
        boatTypeWatch?.value !== 2 &&
        boatTypeWatch?.value !== 6 &&
        boatTypeWatch?.value !== undefined
      ) {
        return enginStaticData;
      }
    } else {
      if (
        userData?.boatType?.value !== 2 &&
        userData?.boatType?.value !== 6 &&
        userData?.boatType?.value !== undefined
      ) {
        return enginStaticData;
      }
    }
    return [];
  };

  const onSubmit = (data, event) => {
    const changeTypeValue = changeTypeWatch?.value;

    function getConditionalValueUser(userDataValue, dataValue) {
      return changeTypeValue === 2 || changeTypeValue === 3
        ? userDataValue
        : dataValue;
    }

    function getConditionalValueShip(userDataValue, dataValue) {
      return changeTypeValue !== 3 ? userDataValue : dataValue;
    }

    const newData = {
      tiketNum: userData.tiketNum,
      personType: userData.personType,
      surname: getConditionalValueUser(userData.surname, data.surname),
      name: getConditionalValueUser(userData.name, data.name),
      midname: getConditionalValueUser(userData.midname, data.midname),
      nameLe: getConditionalValueUser(userData.nameLe, data?.nameLe),
      docType: getConditionalValueUser(
        userData.docType?.value,
        data.docType?.value,
      ),
      serialOfPassport: getConditionalValueUser(
        userData.serialOfPassport,
        data?.serialOfPassport,
      ),
      numberOfPassport: getConditionalValueUser(
        userData.numberOfPassport,
        data.numberOfPassport,
      ),
      persNum: getConditionalValueUser(userData.persNum, data.persNum),
      docDepartment: getConditionalValueUser(
        userData.docDepartment,
        data.docDepartment,
      ),
      docDateIssue: getConditionalValueUser(
        userData.docDateIssue,
        data.docDateIssue,
      ),
      unp: getConditionalValueUser(userData?.unp, data?.unp),
      oblId: getConditionalValueUser(
        userData?.oblId?.value,
        data?.oblId?.value,
      ),
      rayonId: getConditionalValueUser(
        userData?.rayonId?.value,
        data?.rayonId?.value,
      ),
      gorodId: getConditionalValueUser(
        userData?.gorodId?.value,
        data?.gorodId?.value,
      ),
      ulica: getConditionalValueUser(userData.ulica, data.ulica),
      korpus: getConditionalValueUser(userData.korpus, data.korpus),
      dom: getConditionalValueUser(userData.dom, data.dom),
      kv: getConditionalValueUser(userData.kv, data.kv),
      phone: getConditionalValueUser(userData.phone, data.phone),
      docDepartmentLe: getConditionalValueUser(
        userData.docDepartmentLe,
        data.docDepartmentLe,
      ),
      egrNum: getConditionalValueUser(userData.egrNum, data.egrNum),
      agentSurname: data.agentSurname ? data.agentSurname : null,
      agentName: data.agentName ? data.agentName : null,
      agentMidname: data.agentMidname ? data.agentMidname : null,
      agentDocType: data.agentDocType?.value ? data.agentDocType?.value : null,
      agentSerialOfPassport: data.agentSerialOfPassport
        ? data.agentSerialOfPassport
        : null,
      agentNumberOfPassport: data.agentNumberOfPassport
        ? data.agentNumberOfPassport
        : null,
      agentOblId: data.agentOblId?.value ? data.agentOblId?.value : null,
      agentRayonId: data.agentRayonId?.value ? data.agentRayonId?.value : null,
      agentGorodId: data.agentGorodId?.value ? data.agentGorodId?.value : null,
      agentUlica: data.agentUlica ? data.agentUlica : null,
      agentKorpus: data.agentKorpus ? data.agentKorpus : null,
      agentDom: data.agentDom ? data.agentDom : null,
      agentKv: data.agentKv ? data.agentKv : null,
      agentPhone: data.agentPhone ? data.agentPhone : null,
      agentPersNum: data.agentPersNum ? data.agentPersNum : null,
      agentDocDepartment: data.agentDocDepartment
        ? data.agentDocDepartment
        : null,
      agentDocDate: data.agentDocDate ? data.agentDocDate : null,
      boatName: getConditionalValueShip(userData.boatName, data.boatName),
      boatType: getConditionalValueShip(
        userData?.boatType?.value,
        data?.boatType?.value,
      ),
      boatYear: getConditionalValueShip(userData.boatYear, data.boatYear),
      boatVin: getConditionalValueShip(userData.boatVin, data.boatVin),
      boatLength: getConditionalValueShip(userData.boatLength, data.boatLength),
      boatWidth: getConditionalValueShip(userData.boatWidth, data.boatWidth),
      boatHeight: getConditionalValueShip(userData.boatHeight, data.boatHeight),
      bodyMaterial: getConditionalValueShip(
        userData.bodyMaterial.value,
        data.bodyMaterial?.value,
      ),
      boatPayload: getConditionalValueShip(
        userData.boatPayload,
        Number(data.boatPayload),
      ),
      passengersNum: getConditionalValueShip(
        userData.passengersNum,
        Number(data.passengersNum),
      ),
      parkingPlace: getConditionalValueShip(
        userData.parkingPlace,
        data.parkingPlace,
      ),
      engineNum: getConditionalValueShip(
        userData.engineNum,
        Number(data.engineNum),
      ),
      saCategory: getConditionalValueShip(
        userData.saCategory.value,
        data.saCategory?.value,
      ),
      agentDoverennost: data.agentDoverennost ? data.agentDoverennost : null,
      regNum: userData.regNum,
      boatVid: getConditionalValueShip(
        userData.boatVid.value,
        data.boatVid?.value,
      ),
      appDate: data.appDate,
      changeType: data.changeTypeId?.value,
      appSheetCnt: data.appSheetCnt ? Number(data.appSheetCnt) : "",
      appReason: data.appReason,
      billDataId: serviceBill?.id,
      ticketDate: userData.ticketDate,
      note: data?.note ? data.note : null,
      note2: data?.note2 ? data.note2 : null,
      boatCardSpecmarksList: [...userData.boatCardSpecmarksList],
      boatCardModifDealsList: [...userData.boatCardModifDealsList],
      boatArrestsList: [...userData.boatArrestsList],
      enginesList: setEngines(),
      enginesStaticList: setStaticEngines(),
    };

    if (event.nativeEvent.submitter.name === "downloadReport") {
      if (
        newData &&
        newData.enginesList &&
        Array.isArray(newData.enginesList)
      ) {
        newData.enginesList = newData.enginesList.filter(
          (engine) => engine.isNew === true || engine.isTakeOff === true,
        );
      }

      dispatch(downloadReportBoatCardModif(userData.personTypeId, newData));
      setIsPrinted(true);
    } else {
      if (selectedPayWatch.value) {
        setShowBillContractModal(selectedPayWatch?.value);
        setSaveSubmitData(newData);
      } else {
        dispatch(saveApplicationData(idBoadCard, newData, undefined));
      }
    }
  };

  const fetchPageData = (data) => {
    console.log(data);
  };

  const fetchEnginData = (data) => {
    setEnginModalData(data);
  };

  const fetchStaticEnginData = (data) => {
    setEnginStaticModalData(data);
  };

  const handleEnginClick = (type, data) => {
    if (type === "takeOff") {
      dispatch(
        deregisterEngine(idBoadCard, {
          engineVin: data.engvin,
          engname: data.engname,
        }),
      );
    }

    if (type === "edit") {
      setEnginModalOpen(true);
    }

    if (type === "delete") {
      setEnginData((prevEnginData) =>
        prevEnginData.filter((item) => item.id !== data.id),
      );
    }
  };

  const handleStaticEnginClick = (type, data) => {
    if (type === "edit") {
      const totalEngPwr = enginStaticData.reduce(
        (sum, engine) => sum + Number(engine.engpwr || 0),
        0,
      );

      const remainingPowerCount =
        Number(getValues().engpwrmax) - totalEngPwr + Number(data.engpwr);

      setRemainingPower(remainingPowerCount > 0 ? remainingPowerCount : 0);

      setEnginStaticModalOpen(true);
    }

    if (type === "delete") {
      setEnginStaticData((prevEnginData) =>
        prevEnginData.filter((item) => item.id !== data.id),
      );
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();

    return `${day}.${month}.${year}`;
  };

  const handleEngineData = (data) => {
    if (Object.keys(enginModalData).length === 0) {
      const newEngine = {
        ...data,
        id: String(nextId),
        dateReg: getCurrentDate(),
        isEditable: true,
        idDeleted: true,
        isNew: true,
      };
      const newEnginData = [...enginData, newEngine];
      setEnginData(newEnginData);
      setNextId(nextId + 1);
    } else {
      const updatedEnginData = enginData.map((item) =>
        item.id === enginModalData.id ? { ...item, ...data } : item,
      );
      setEnginData(updatedEnginData);
    }
  };

  const handleStaticEngineData = (data) => {
    const updatedEnginData = enginStaticData.map((item) =>
      item.id === enginStaticModalData.id ? { ...item, ...data } : item,
    );
    setEnginStaticData(updatedEnginData);
  };

  const handleCustomButtonClick = async (buttonId) => {
    if (buttonId === "customButton") {
      const isValidPersNum = await trigger("persNum");
      if (isValidPersNum) {
        handlePasswordModalShow();
        setAgenNumber(1);
      }
    }
    if (buttonId === "customButton2") {
      const isValidAgentPersNum = await trigger("agentPersNum");
      if (isValidAgentPersNum && agentPersNumWatch.length > 0) {
        handlePasswordModalShow();
        setAgenNumber(2);
      }
    }

    if (buttonId === "customButton3") {
      firstRender.current = true;
      dispatch(sendUnp(getValues("unp")));
    }
  };

  useEffect(() => {
    if (dataByUnpError === "error") {
      handleShowTakeOffModal(true);
      setTakeOffTextModal("Данные в ЕГР отсутствуют. Введите вручную");
    }
    dispatch({ type: GET_DATA_BU_UNP_REQUEST });
  }, [dataByUnpError]);

  useEffect(() => {
    if (Object.keys(dataByUnp).length > 0) {
      reset({
        ...getValues(),
        nameLe: "",
        docDepartmentLe: "",
        egrNum: "",
        rayonId: null,
        ulica: "",
        kv: "",
        oblId: null,
        gorodId: null,
        dom: "",
        korpus: "",
        phone: "",
        ...dataByUnp,
      });
    }
  }, [dataByUnp]);

  useEffect(() => {
    if (!isCreateEnginData) {
      if (userData?.enginesList?.length > 0) {
        setIsCreateEnginData(true);
        setEnginData(userData.enginesList);
      }
      if (userData?.engineStaticList?.length > 0) {
        setIsCreateEnginData(true);
        setEnginStaticData(userData.engineStaticList);
      }
    }
  }, [userData.enginesList, userData.engineStaticList]);

  useEffect(() => {
    if (dictionaryReducer) {
      setInterestedPartyFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "docType",
          dictionaryReducer.identificationDocuments,
        ),
      );
      setAgentFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "agentDocType",
          dictionaryReducer.identificationDocuments,
        ),
      );
      setInterestedPartyFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "oblId",
          dictionaryReducer.allOblast,
        ),
      );
      setEntityFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "oblId",
          dictionaryReducer.allOblast,
        ),
      );
      setAgentFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "agentOblId",
          dictionaryReducer.allOblast,
        ),
      );
      setSmallVesselFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "boatVid",
          dictionaryReducer.kindsBoats,
        ),
      );

      setSmallVesselFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "bodyMaterial",
          dictionaryReducer.allBoatBodyMaterial,
        ),
      );
      setSmallVesselFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "saCategory",
          dictionaryReducer.allSwimmingDifficultyCategory,
        ),
      );
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (rayonAndRegionReducer) {
      setInterestedPartyFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "rayonId",
          rayonAndRegionReducer.rayon,
        ),
      );
      setEntityFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "rayonId",
          rayonAndRegionReducer.rayon,
        ),
      );
      setInterestedPartyFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "gorodId",
          rayonAndRegionReducer.gorod,
        ),
      );
      setEntityFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "gorodId",
          rayonAndRegionReducer.gorod,
        ),
      );
      setAgentFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "agentGorodId",
          rayonAndRegionReducer.gorodAgent,
        ),
      );
      setAgentFields((prevFields) =>
        setSelectOptionsForFields(
          prevFields,
          "agentRayonId",
          rayonAndRegionReducer.rayonAgent,
        ),
      );
    }
  }, [rayonAndRegionReducer]);

  useEffect(() => {
    if (changeTypeWatch) {
      firstRender.current = true;
      dispatch({ type: GET_DATA_BU_UNP_REQUEST });
    }
  }, [changeTypeWatch]);

  useEffect(() => {
    if (rayonIdWatch && oblIdWatch) {
      dispatch(getGorodIdByRayons(rayonIdWatch.value, 1));
    }

    if (gorodIdWatch && oblIdWatch) {
      dispatch(getRayonsByGorodId(gorodIdWatch.value, 1));
    }
  }, [rayonIdWatch, gorodIdWatch]);

  useEffect(() => {
    if (agentRayonIdWatch && agentOblIdWatch) {
      dispatch(getGorodIdByRayons(agentRayonIdWatch.value, 2));
    }

    if (agentGorodIdWatch && agentOblIdWatch) {
      dispatch(getRayonsByGorodId(agentGorodIdWatch.value, 2));
    }
  }, [agentGorodIdWatch, agentRayonIdWatch]);

  useEffect(() => {
    if (dirtyFields.persNum) {
      trigger("persNum");
    }
  }, [persNumWatch]);

  useEffect(() => {
    if (dirtyFields.agentPersNum) {
      trigger("agentPersNum");
    }
  }, [agentPersNumWatch]);

  useEffect(() => {
    if (!oblIdWatch?.value) {
      return;
    }

    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    dispatch(getRayonByOblast(oblIdWatch.value, 1));
    dispatch(getGorodByObl(oblIdWatch.value, 1));

    if (oblIdWatch?.value !== agentDataByNumber.oblId?.value) {
      setValue("gorodId", null);
      setValue("rayonId", null);
    }

    if (oblIdWatch.value === 5) {
      setValue("gorodId", null);
      setValue("rayonId", null);

      setEntityFields((prevFields) =>
        setDisabledForFields(prevFields, ["gorodId", "rayonId"], true),
      );
      setInterestedPartyFields((prevFields) =>
        setDisabledForFields(prevFields, ["gorodId", "rayonId"], true),
      );
    }

    if (oblIdWatch.value !== 5) {
      setEntityFields((prevFields) =>
        setDisabledForFields(prevFields, ["gorodId", "rayonId"], false),
      );
      setInterestedPartyFields((prevFields) =>
        setDisabledForFields(prevFields, ["gorodId", "rayonId"], false),
      );
    }
  }, [oblIdWatch]);

  useEffect(() => {
    if (!registrationIsLoading) {
      if (registrationResult === "success") {
        handleShowResultModal(true);
        setResultTextHeaderModal("Заявление успешно зарегистрировано!");
        setResultTextModal(appName);
      }

      if (registrationResult === "error") {
        handleShowResultModal(true);
        setResultTextHeaderModal("");
        setResultTextModal("Ошибка сохранения данных");
      }
    }
  }, [registrationIsLoading]);

  useEffect(() => {
    if (!deregisterEngineLoading) {
      if (deregisterEngineError === "error") {
        handleShowTakeOffModal(true);
        setTakeOffTextModal("Ошибка снятия двигателя с учёта");
      }

      if (deregisterEngineError === "success") {
        handleShowTakeOffModal(true);
        setTakeOffTextModal("Двигатель снят с учёта");

        const updatedEnginData = enginData.map((engine) => {
          if (engine.id === enginModalData.id) {
            return {
              ...engine,
              isTakeOff: false,
              dateRegEnd: new Date()
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "."),
            };
          }
          return engine;
        });

        setEnginData(updatedEnginData);
      }
      dispatch({ type: DEREGISTER_RESET_STATUS_ERROR });
    }
  }, [deregisterEngineLoading]);

  useEffect(() => {
    if (!agentOblIdWatch?.value) {
      return;
    }

    dispatch(getRayonByOblast(agentOblIdWatch.value, 2));
    dispatch(getGorodByObl(agentOblIdWatch.value, 2));

    if (agentOblIdWatch.value !== 5) {
      setAgentFields((prevFields) =>
        setDisabledForFields(
          prevFields,
          ["agentGorodId", "agentRayonId"],
          false,
        ),
      );
    }

    if (agentOblIdWatch?.value !== agentDataByNumber.agentOblId?.value) {
      setValue("agentGorodId", null);
      setValue("agentRayonId", null);
    }

    if (agentOblIdWatch.value === 5) {
      setValue("agentGorodId", null);
      setValue("agentRayonId", null);

      setAgentFields((prevFields) =>
        setDisabledForFields(
          prevFields,
          ["agentGorodId", "agentRayonId"],
          true,
        ),
      );
    }
  }, [agentOblIdWatch]);

  useEffect(() => {
    if (!oblIdWatch) {
      setInterestedPartyFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], false),
      );
      setEntityFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], false),
      );
    } else if (oblIdWatch && oblIdWatch.value === 5) {
      setInterestedPartyFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], false),
      );
      setEntityFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], false),
      );
    } else if (
      gorodIdWatch &&
      gorodIdWatch.label?.includes("г.") &&
      !gorodIdWatch.label?.includes("аг.")
    ) {
      setInterestedPartyFields((prevFields) =>
        setRequirementForFields(prevFields, ["rayonId"], false),
      );
      setEntityFields((prevFields) =>
        setRequirementForFields(prevFields, ["rayonId"], false),
      );
    } else {
      setInterestedPartyFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], true),
      );
      setEntityFields((prevFields) =>
        setRequirementForFields(prevFields, ["gorodId", "rayonId"], true),
      );
    }
  }, [oblIdWatch, gorodIdWatch]);

  useEffect(() => {
    setError("gorodId", false);
    setError("rayonId", false);
  }, [oblIdWatch, gorodIdWatch]);

  useEffect(() => {
    if (!agentOblIdWatch) {
      setAgentFields((prevFields) =>
        setRequirementForFields(
          prevFields,
          ["agentGorodId", "agentRayonId"],
          false,
        ),
      );
    } else if (agentOblIdWatch && agentOblIdWatch.value === 5) {
      setAgentFields((prevFields) =>
        setRequirementForFields(
          prevFields,
          ["agentGorodId", "agentRayonId"],
          false,
        ),
      );
    } else if (
      agentGorodIdWatch &&
      agentGorodIdWatch.label?.includes("г.") &&
      !agentGorodIdWatch.label?.includes("аг.")
    ) {
      setAgentFields((prevFields) =>
        setRequirementForFields(prevFields, ["agentRayonId"], false),
      );
    } else {
      setAgentFields((prevFields) =>
        setRequirementForFields(
          prevFields,
          ["agentGorodId", "agentRayonId"],
          true,
        ),
      );
    }
  }, [agentOblIdWatch, agentGorodIdWatch]);

  useEffect(() => {
    setError("agentGorodId", false);
    setError("agentRayonId", false);
  }, [agentOblIdWatch, agentGorodIdWatch]);

  useEffect(() => {
    setSmallVesselFields((prevFields) =>
      setSelectOptionsForFields(
        prevFields,
        "boatType",
        boatTypeWatch?.value === 6 || boatTypeWatch?.value === 2
          ? dictionaryReducer.boatTypes.filter(
              (boatType) => boatType.value === 6 || boatType.value === 2,
            )
          : dictionaryReducer.boatTypes,
      ),
    );

    if (
      !boatTypeWatch?.value ||
      boatTypeWatch?.value === 6 ||
      boatTypeWatch?.value === 2
    ) {
      setSmallVesselFields((prevFields) =>
        setDisabledForFields(prevFields, ["boatType", "boatVid"], false),
      );
    } else {
      setSmallVesselFields((prevFields) =>
        setDisabledForFields(prevFields, ["boatType", "boatVid"], true),
      );
    }
  }, [boatTypeWatch]);

  useEffect(() => {
    if (changeTypeWatch?.value && changeTypeWatch?.value !== 3) {
      setEnginData((prevEnginData) =>
        prevEnginData.map((item) => ({
          ...item,
          isEditable: false,
          idDeleted: false,
        })),
      );

      setEnginStaticData((prevEnginData) =>
        prevEnginData.map((item) => ({
          ...item,
          isEditable: false,
        })),
      );

      dispatch(interestedUserData(idBoadCard));
    } else {
      setEnginStaticData((prevEnginData) =>
        prevEnginData.map((item) => ({
          ...item,
          isEditable: true,
          isTakeOff: false,
        })),
      );

      setEnginData((prevEnginData) =>
        prevEnginData.map((item) => ({
          ...item,
          isTakeOff: !item.isNew && !item.dateRegEnd,
          isEditable: !!item.isNew,
          idDeleted: !!item.isNew,
        })),
      );

      dispatch(interestedUserData(idBoadCard));
    }
  }, [changeTypeWatch]);

  useEffect(() => {
    if (showBillContractModal) {
      const addressString = `РБ, ${
        getValues("oblId")
          ? getValues("oblId")?.label
          : userData.oblId?.label || ""
      },${
        getValues("rayonId")
          ? getValues("rayonId")?.label
          : userData.rayonId?.label || ""
      }, ${
        getValues("gorodId")
          ? getValues("gorodId")?.label
          : userData.gorodId?.label || ""
      }${
        getValues("ulica")
          ? `, ул. ${getValues("ulica")}`
          : userData.ulica
          ? `, ул. ${userData.ulica}`
          : ""
      }${
        getValues("dom")
          ? `, д. ${getValues("dom")}`
          : userData.dom
          ? `, д. ${userData.dom}`
          : ""
      }${
        getValues("korpus")
          ? `, к. ${getValues("korpus")}`
          : userData.korpus
          ? `, к. ${userData.korpus}`
          : ""
      }${
        getValues("kv")
          ? `, кв. ${getValues("kv")}`
          : userData.kv
          ? `, кв. ${userData.kv}`
          : ""
      }`;

      const setCodeNumber = () => {
        if (getValues("boatType")) {
          if (getValues("boatType").value === 6) {
            return "200001";
          } else {
            return "200002";
          }
        } else {
          if (userData.boatType.value === 6) {
            return "200001";
          } else {
            return "200002";
          }
        }
      };

      dispatch(
        createBill({
          address: addressString,
          surname: getValues("surname")
            ? getValues("surname")
            : userData.surname,
          name: getValues("name") ? getValues("name") : userData.name,
          midname: getValues("midname")
            ? getValues("midname")
            : userData.midname,
          programId: null,
          phone: getValues("phone") ? getValues("phone") : userData.phone,
          paidProcType: null,
          codeNumber: setCodeNumber(),
        }),
      );
    }
  }, [showBillContractModal]);

  useEffect(() => {
    if (modeView === "view") {
    } else {
      setValue("changeTypeId", {
        value: 2,
        label: "Снятие с учета",
        key: "idTypeChangeStatement",
      });
      dispatch(interestedUserData(idBoadCard));
    }

    return () => {
      dispatch({ type: GET_DATA_BU_UNP_REQUEST });
      dispatch({
        type: SET_INTERESTED_USER_DATA,
        payload: {},
      });
      setIsCreateEnginData(false);
    };
  }, []);

  useEffect(() => {
    if (
      boatTypeWatch?.value &&
      boatTypeWatch?.value !== 6 &&
      boatTypeWatch?.value !== 2
    ) {
      const totalEngPwr = enginStaticData.reduce(
        (sum, engine) => sum + Number(engine.engpwr || 0),
        0,
      );

      const countEngin = Number(engineNumWatch) || 0;
      const countMax = Number(engpwrmaxWatch) || 0;
      if (
        enginStaticData.length !== countEngin &&
        changeTypeWatch?.value === 3
      ) {
        setError("tableEngin", {
          type: "manual",
          message: "Введённое количество двигателей не совпадает",
        });
      } else if (changeTypeWatch?.value === 3 && totalEngPwr !== countMax) {
        setError("tableEngin", {
          type: "manual",
          message:
            "Сумма мощностей не совпадает с предельной мощностью двигателей",
        });
      } else {
        clearErrors("tableEngin");
      }
    }
  }, [enginStaticData, engineNumWatch, engpwrmaxWatch, changeTypeWatch]);

  useEffect(() => {
    if (boatTypeWatch?.value === 2) {
      const countMax = Number(engpwrmaxWatch) || 0;

      const hasOverpoweredEngine = enginData.some(
        (engine) => engine.engpwr > countMax,
      );

      if (hasOverpoweredEngine && changeTypeWatch?.value === 3) {
        setError("tableEngin", {
          type: "manual",
          message:
            "Мощность одного из двигателей превышает максимально допустимую",
        });
      } else {
        clearErrors("tableEngin");
      }
    }
  }, [enginData, boatTypeWatch, engpwrmaxWatch, changeTypeWatch]);

  useEffect(() => {
    setAgentFields((prevFields) =>
      setRequirementForFields(
        prevFields,
        [
          "agentPersNum",
          "agentSurname",
          "agentName",
          "agentOblId",
          "agentDom",
          "agentDocType",
          "agentSerialOfPassport",
          "agentNumberOfPassport",
          "agentDocDate",
          "agentDocDepartment",
        ],
        userData?.personTypeId === 2,
      ),
    );
  }, [userData]);

  useEffect(() => {
    if (boatTypeWatch?.value === 6) {
      setSmallVesselFields((prevFields) =>
        setDisabledForFields(prevFields, ["engineNum", "engpwrmax"], true),
      );
      setValue("engineNum", 0);
      setValue("engpwrmax", 0);
    }

    if (boatTypeWatch?.value === 2) {
      setSmallVesselFields((prevFields) =>
        setDisabledForFields(prevFields, ["engineNum", "engpwrmax"], false),
      );
    }
  }, [boatTypeWatch]);

  useEffect(() => {
    const hasEnginesTakenOff = enginData.some((engine) => engine.isTakeOff);

    if (boatTypeWatch?.value === 6 && hasEnginesTakenOff) {
      setError("tableEngin", {
        type: "manual",
        message: "Необходимо снять все двигатели",
      });
    }

    if (boatTypeWatch?.value === 6 && !hasEnginesTakenOff) {
      clearErrors("tableEngin");
    }
  }, [boatTypeWatch, enginData]);

  useEffect(() => {
    if (agentDataByNumber) {
      reset({ ...getValues(), ...agentDataByNumber });
    }
  }, [agentDataByNumber]);

  useEffect(() => {
    if (userDataByNumber) {
      reset({ ...getValues(), ...userDataByNumber });
    }
  }, [userDataByNumber]);

  return (
    <>
      <form
        className={styles["content-container"]}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className={styles["header-text-info"]}>
          О регистрации изменений сведений, подлежащих внесению в судовую книгу
          для маломерного судна, за исключением гребных лодок, байдарок и
          надувных судов грузоподъемностью менее 225 килограммов
        </div>

        <div className={styles["header-text-info"]}>
          {userData.boatCardSpecmarksList?.find((el) => el.msmLock === true) &&
            changeTypeWatch.value !== 1 && (
              <p className={"text-danger"}>
                На данное судно наложено(ы) ограничения!!!
              </p>
            )}
          {userData.boatArrestsList?.find((el) => el.isActiv === true) &&
            changeTypeWatch.value !== 1 && (
              <p className={"text-danger"}>
                На данное судно наложен(ы) аресты!!!
              </p>
            )}
          <div className={styles["header-text-info-selector"]}>
            <label>Какие изменения вносятся:</label>
            <Controller
              name="changeTypeId"
              control={control}
              render={({ field }) => (
                <Select
                  styles={registrationStyles}
                  {...field}
                  options={registrationChangeType}
                />
              )}
            />
          </div>
          <DisplayFields
            values={userData}
            fields={registrationFieldsHeader}
            singleColumn={true}
          />
        </div>

        {idTypeStatement === 1 && (
          <>
            <h4>Сведения о заинтересованном лице</h4>
            <div className={styles["header-text-info"]}>
              {changeTypeWatch?.value === 2 || changeTypeWatch?.value === 3 ? (
                <DisplayFields
                  values={userData}
                  fields={informationAboutInterestedPartyText}
                  headers={{ first: "Личные данные", second: "Адрес" }}
                />
              ) : (
                <DynamicForm
                  fields={interestedPartyFields}
                  control={control}
                  setValue={setValue}
                  initialValues={
                    Object.keys(userDataByNumber).length > 0
                      ? userDataByNumber
                      : userData
                  }
                  stylesFromParent={stylesFirsForm}
                  onCustomButtonClick={handleCustomButtonClick}
                />
              )}
            </div>
          </>
        )}

        {idTypeStatement === 2 && (
          <>
            <h4>Сведения о заинтересованном лице</h4>
            <div className={styles["header-text-info"]}>
              {changeTypeWatch?.value === 2 || changeTypeWatch?.value === 3 ? (
                <DisplayFields
                  values={userData}
                  fields={entityInformationAboutInterestedPartyText}
                />
              ) : (
                <DynamicForm
                  fields={entityFields}
                  control={control}
                  setValue={setValue}
                  initialValues={
                    Object.keys(dataByUnp).length > 0 ? dataByUnp : userData
                  }
                  stylesFromParent={stylesEntityForm}
                  onCustomButtonClick={handleCustomButtonClick}
                />
              )}
            </div>
          </>
        )}

        <h4>
          Сведения о представителе заинтересованного лица
          {userData.personTypeId === 2 && (
            <span className={styles["error-text"]}>*</span>
          )}
        </h4>

        <div className={styles["header-text-info"]}>
          <DynamicForm
            fields={agentFields}
            control={control}
            setValue={setValue}
            initialValues={
              agentDataByNumber
                ? agentDataByNumber
                : { agentCountry: "Республика Беларусь" }
            }
            stylesFromParent={stylesSecondForm}
            onCustomButtonClick={handleCustomButtonClick}
          />
        </div>

        <h4>Сведения о маломерном судне</h4>
        <div className={styles["header-text-info"]}>
          {changeTypeWatch?.value === 3 ? (
            <DynamicForm
              fields={smallVesselFields}
              control={control}
              setValue={setValue}
              initialValues={userData}
              stylesFromParent={stylesThirdForm}
            />
          ) : (
            <DisplayFields
              values={userData}
              fields={informationAboutSmallVesselText}
            />
          )}
        </div>

        <div className={styles["table"]}>
          {(changeTypeWatch?.value === 3
            ? boatTypeWatch?.value === 6 || boatTypeWatch?.value === 2
            : userData?.boatType?.value === 6 ||
              userData?.boatType?.value === 2) && (
            <>
              <h2>Сведения о подвесных двигателях маломерного судна</h2>
              {errors.tableEngin && (
                <p className={styles["error-text"]}>
                  {errors.tableEngin.message}
                </p>
              )}
              {changeTypeWatch?.value === 3 && (
                <div
                  className={`${styles["buttons-block"]} ${styles["buttons-block-start"]}`}
                >
                  <button
                    onClick={openEngineModal}
                    className={styles["add-btn"]}
                    disabled={boatTypeWatch?.value === 6}
                    type="button"
                  >
                    <span className={styles["plus-icon"]}></span>
                    <p className={styles.buttons_text}>Добавить</p>
                  </button>
                </div>
              )}
              <TableComponent
                headerName=" "
                columns={SMALL_BOAT_OUTBOARD_ENGINES}
                data={enginData ? enginData : []}
                fetchData={fetchEnginData}
                onRowSelect={fetchEnginData}
                totalPages={1}
                selectedPage={0}
                isPaginated={false}
                pageSize={100}
                onButtonClick={handleEnginClick}
              />
            </>
          )}
          {(changeTypeWatch?.value === 3
            ? boatTypeWatch?.value !== 2 &&
              boatTypeWatch?.value !== 6 &&
              boatTypeWatch?.value !== undefined
            : userData?.boatType?.value !== 2 &&
              userData?.boatType?.value !== 6 &&
              userData?.boatType?.value !== undefined) && (
            <>
              <h2>Сведения о стационарных двигателях маломерного судна</h2>
              {errors.tableEngin && (
                <p className={styles["error-text"]}>
                  {errors.tableEngin.message}
                </p>
              )}
              <TableComponent
                headerName=" "
                columns={STATIONARY_ENGINES_SMALL_VESSELS}
                data={enginStaticData ? enginStaticData : []}
                fetchData={fetchStaticEnginData}
                onRowSelect={fetchStaticEnginData}
                totalPages={1}
                selectedPage={0}
                isPaginated={false}
                pageSize={100}
                onButtonClick={handleStaticEnginClick}
              />
            </>
          )}
        </div>

        <div className={styles["table"]}>
          <TableComponent
            headerName="Налагаемые аресты"
            columns={ARRESTS_IMPOSED}
            data={userData?.boatArrestsList ? userData?.boatArrestsList : []}
            fetchData={fetchPageData}
            onRowSelect={fetchPageData}
            totalPages={1}
            selectedPage={0}
            isPaginated={false}
            pageSize={100}
          />
        </div>

        {changeTypeWatch?.value === 4 && (
          <OtherInformationRHF
            mode={"add"}
            register={register}
            newData={userData}
          />
        )}

        <div className={styles["table"]}>
          <TableComponent
            headerName="Особые отметки"
            columns={SPECIAL_NOTES}
            data={
              userData?.boatCardSpecmarksList
                ? userData?.boatCardSpecmarksList
                : []
            }
            fetchData={fetchPageData}
            onRowSelect={fetchPageData}
            totalPages={1}
            selectedPage={0}
            isPaginated={false}
            pageSize={
              userData?.boatCardSpecmarksList?.length
                ? userData?.boatCardSpecmarksList?.length
                : 1
            }
          />
        </div>

        <h4>Основание для внесения изменений</h4>
        <p className={styles["description-text"]}>
          {`Укажите документ, представленный заявителем для обоснования вносимых изменений
          (свидетельство о браке и паспорт, руководство по эксплуатации двигателя с отметкой о продаже, 
          документы о продаже, правоустанавливающие и иные документы`}
        </p>
        <div>
          <Controller
            className={styles["full-textarea"]}
            name="appReason"
            control={control}
            render={({ field }) => (
              <textarea
                {...field}
                placeholder={"Основание"}
                className={styles["full-textarea"]}
                rows="3"
              />
            )}
          />
        </div>

        {idTypeStatement === 1 && (
          <div className={styles["count"]}>
            <label>Выставить счет на оплату</label>
            <Controller
              name="selectedPay"
              control={control}
              rules={{ required: "Заполните поле" }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                    {...field}
                    styles={registrationStyles}
                    options={[
                      { value: true, label: "Да" },
                      { value: false, label: "Нет" },
                    ]}
                    placeholder="Выберите"
                  />
                  {error && (
                    <span style={{ color: "red" }}>{error.message}</span>
                  )}
                </>
              )}
            />
          </div>
        )}

        <div className={styles["count-list"]}>
          <label>Количество листов</label>
          <Controller
            className={styles["full-textarea"]}
            name="appSheetCnt"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                placeholder={"Введите"}
                className={styles["full-textarea"]}
              />
            )}
          />
        </div>

        <div className={styles["count-list"]}>
          <label>Дата подачи заявления</label>
          <Controller
            name="appDate"
            control={control}
            rules={{
              required: "Введите дату",
              validate: (value) => {
                const selectedDate = new Date(value);
                const today = new Date();
                return selectedDate <= today || "Дата не может быть в будущем";
              },
            }}
            render={({ field }) => (
              <>
                <input
                  className={styles["date"]}
                  type={"date"}
                  {...field}
                  placeholder={"Введите"}
                />
                {errors.appDate && (
                  <p className={styles["error-text"]}>
                    {errors.appDate.message}
                  </p>
                )}
              </>
            )}
          />
        </div>

        <div className={styles["footer-info-user"]}>
          <DisplayFields
            values={{ executive: dictionaryReducer?.userInfo?.name }}
            fields={[{ id: "executive", label: "Должностное лицо" }]}
            singleColumn={true}
          />
        </div>

        <div
          className={`${styles["buttons-block"]} ${styles["buttons-block-end"]}`}
        >
          {!isPrinted && (
            <button
              onClick={() => navigate(-1)}
              type="button"
              className={styles["clear-btn"]}
            >
              Закрыть
            </button>
          )}

          {((userData.boatCardSpecmarksList?.length === 0 ||
            userData.boatCardSpecmarksList?.every(
              (el) => el.msmLock === false,
            )) &&
            (userData.boatArrestsList?.length === 0 ||
              userData.boatArrestsList?.every((el) => el.isActiv === false))) ||
          changeTypeWatch?.value === 1 ? (
            <button
              className={styles["add-btn"]}
              type="submit"
              name="downloadReport"
            >
              <p className={styles.buttons_text}>Распечатать</p>
            </button>
          ) : null}
          {((userData.boatCardSpecmarksList?.length === 0 ||
            userData.boatCardSpecmarksList?.every(
              (el) => el.msmLock === false,
            )) &&
            (userData.boatArrestsList?.length === 0 ||
              userData.boatArrestsList?.every((el) => el.isActiv === false))) ||
          changeTypeWatch?.value === 1 ? (
            <button name="sendData" className={styles["add-btn"]} type="submit">
              <p className={styles.buttons_text}>Зарегистрировать</p>
            </button>
          ) : null}
        </div>
      </form>

      <EngineStaticModal
        onSubmit={handleStaticEngineData}
        isOpen={enginStaticModalOpen}
        onClose={closeEngineModal}
        initialValues={enginStaticModalData}
        remainingPower={remainingPower}
        engpwrmax={getValues()?.engpwrmax}
        enginStaticData={enginStaticData}
        regNum={userData.regNum}
      />

      <EngineModal
        engineTypes={dictionaryReducer?.allEngineTypes}
        onSubmit={handleEngineData}
        isOpen={enginModalOpen}
        onClose={closeEngineModal}
        initialValues={enginModalData}
        engpwrmax={getValues()?.engpwrmax}
      />

      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill?.id}
          billQRurl={serviceBill?.QRurl}
          onClose={QRModalWindowCloseModal}
        />
      )}

      <PasswordModal
        show={passwordModalShow}
        handleClose={handlePasswordModalClose}
        handleSave={handleSavePassword}
      />

      <ResultModalText
        show={showTakeOffModal}
        handleClose={handleCloseTakeOffModal}
        text={takeOffTextModal}
      />
      <ResultModalText
        headerName={resultTextHeaderModal}
        show={showResultModal}
        handleClose={handleCloseResultModal}
        text={resultTextModal}
      />
    </>
  );
};

export default RegistrationChangesInformationRHFNew;
